export default "__VITE_ASSET__Bskm5TH0__"